import React from 'react';
import styles from '../styles/menu.module.scss';
import { Icon, IconName } from '../../assets/icons';

interface SidebarSectionProps {
  title: string;
  actionIcon?: IconName;
  onActionClick?: () => void;
  children: React.ReactNode;
}

export const SidebarSection: React.FC<SidebarSectionProps> = ({
  title,
  actionIcon,
  onActionClick,
  children,
}) => (
  <div className={styles.sidebarSection}>
    <div className={styles.sectionHeader}>
      <span className={styles.sectionTitle}>{title}</span>
      {actionIcon && (
        <button className={styles.sectionAction} onClick={onActionClick} tabIndex={0}>
          <Icon name={actionIcon} />
        </button>
      )}
    </div>
    <div className={styles.sectionContent}>{children}</div>
  </div>
);

export default SidebarSection; 